import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

// Utility: get color based on profit %
const getHeatColor = (value) => {
  if (value >= 99.9) return "#22C55E"; // green
  if (value >= 99.5) return "#EAB308"; // yellow
  return "#EF4444"; // red
};

// const branches = ["MAIN", "BR001", "BR002", "BR003"]; // You can fetch this from API too

const ProfitHeatmap = ({ endpoint }) => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"


  const [financialData, setFinancialData] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [selectedBranchCode, setSelectedBranchCode] = useState([]);

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const todayDate = getTodayDate();






  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(
          `https://cubixweberp.com:213/api/MasterCount/${company_code_from_local_storage}/BRANCH/ADMIN/-`
        );
        const data = response.data;
        const branchArray = Array.isArray(data) ? data : [data];
        console.log('branchArray', branchArray)
        setBranches(branchArray);

        // Automatically select the first branch
        if (branchArray.length > 0) {
          //   setSelectedBranch(branchArray[0].DEPTNO);
          setSelectedBranch(branchArray[0]);
        }
      } catch (error) {
        console.error("Failed to fetch branches", error);
      }
    };

    fetchBranches();
  }, []);

  useEffect(() => {
    console.log('selectedBranch', selectedBranch)
    if (selectedBranch) {
      fetchFinancialData(selectedBranch);
    }
  }, [selectedBranch]);


  useEffect(() => {
    console.log('selectedbranchCode', selectedBranchCode)

    const selected = branches?.find(
      (branch) => branch.DEPTNO === selectedBranchCode
    );
    setSelectedBranch(selected);
    console.log('selected', selected)
  }, [selectedBranchCode])

  const fetchFinancialData = async (selectedBranch) => {
    try {
      const response = await axios.get(
        `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/${selectedBranch.DEPTNO}/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`
      );
      const data = response.data || [];
      setFinancialData(data);
    } catch (err) {
      console.error("Error while fetching financial data", err);
    }
  }
  return (
    <div className="mt-2 col-span-1 lg:col-span-3 rounded-lg p-4  w-full">
      <div className="flex justify-between items-center mb-4">
        <div className="flex justify-left gap-4 items-center mb-4">
          {/* <h2 className="text-md sm:text-xl font-medium text-gray-700">
          Profit % Heatmap ({selectedBranch?.DEPTNO})
        </h2> */}

          {selectedBranch && (
            <div className="mt-2 text-sm text-gray-700">
              Selected Branch dd:{" "}
              <strong>
                {selectedBranch.deptnodesc} ({selectedBranch.DEPTNO})
              </strong>
            </div>
          )}
        </div>

        <select
          //   value={selectedBranch}
          value={selectedBranch?.DEPTNO || ""}
          //   onChange={(e) => {
          //     const selected = branches?.find(
          //       (branch) => branch.deptnodesc === e.target.value
          //     );
          //     setSelectedBranch(selected);
          //   }}
          onChange={(e) => setSelectedBranchCode(e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        >

          {console.log("branches ", branches)}
          {branches?.map((branch) => (
             
          <option key={branch.DEPTNO} value={branch.DEPTNO}>
            {branch.deptnodesc}
          </option>
          
          ))}
        </select>
      </div>

      {financialData.length > 0 ? (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            layout="vertical"
            data={financialData}
            // data={financialData?.DEPTNO}
            margin={{ top: 20, right: 30, left: 40, bottom: 10 }}
            barCategoryGap={10}
          >
            <XAxis type="number" hide />
            <YAxis type="category" dataKey="Month" />
            <Tooltip
              formatter={(value) => `${value}%`}
              labelFormatter={(label) => `Month: ${label}`}
            />
            <Bar dataKey="ProfitPercent" barSize={20}>
              {financialData?.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={getHeatColor(entry.ProfitPercent)}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <p className="text-center text-sm text-gray-500">No data available</p>
      )}
    </div>
  );
};

export default ProfitHeatmap;